import React from 'react';
import { Box, ButtonBase, Typography, useTheme } from '@mui/material';
import { FeedbackKind, feedbackMessageText } from '../hooks/clipDownloadFeedback';

interface ClipFeedbackMessageProps {
  kind: FeedbackKind;
  /** Full camera name ("Left Rocker"), or the Auto-Director label. */
  cameraName: string;
  onDismiss: () => void;
}

/**
 * The status line under a clip group's download buttons (Figma Game View,
 * "message-area" in node 4348:16338): generating / created / failed copy, with
 * a Dismiss action on the failure variant.
 */
export const ClipFeedbackMessage: React.FC<ClipFeedbackMessageProps> = ({
  kind,
  cameraName,
  onDismiss,
}) => {
  const palette = useTheme().palette.cx;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        borderRadius: '6px',
        backgroundColor: palette.bg.surface,
        px: 1,
        pt: '6px',
        pb: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '16px',
          color: kind === 'error' ? palette.red.main : palette.light[200],
        }}
      >
        {feedbackMessageText(kind, cameraName)}
      </Typography>

      {kind === 'error' && (
        <ButtonBase
          onClick={(clickEvent) => {
            clickEvent.stopPropagation();
            onDismiss();
          }}
          sx={{
            flexShrink: 0,
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '16px',
            color: palette.washDark[400],
            '&:hover': { color: palette.text.secondary },
          }}
        >
          Dismiss
        </ButtonBase>
      )}
    </Box>
  );
};

export default ClipFeedbackMessage;
